var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "designer-menu",
        class: { "timer-trigger": _vm.automation.options.trigger === "timer" },
      },
      [
        _c(
          "div",
          { staticClass: "btnGroup" },
          [
            _c(
              "SupsisButton",
              {
                attrs: {
                  primary: _vm.selectedTab === "designer",
                  ghost: _vm.selectedTab !== "designer",
                },
                on: {
                  click: function () {
                    return _vm.toggleSelectedTab("designer")
                  },
                },
              },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("draw")]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.designer")) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _vm.automation.options.trigger === "timer"
              ? _c(
                  "SupsisButton",
                  {
                    attrs: {
                      primary: _vm.selectedTab === "target-contacts",
                      ghost: _vm.selectedTab !== "target-contacts",
                    },
                    on: {
                      click: function () {
                        return _vm.toggleSelectedTab("target-contacts")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("track_changes"),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("message.targetContacts")) +
                        "\n            "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.automation.options.trigger === "timer"
              ? _c(
                  "SupsisButton",
                  {
                    attrs: {
                      primary: _vm.selectedTab === "scheduler",
                      ghost: _vm.selectedTab !== "scheduler",
                    },
                    on: {
                      click: function () {
                        return _vm.toggleSelectedTab("scheduler")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("schedule"),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("message.scheduler")) +
                        "\n            "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.automation.options.trigger === "webhook"
              ? _c(
                  "SupsisButton",
                  {
                    attrs: {
                      primary: _vm.selectedTab === "webhook",
                      ghost: _vm.selectedTab !== "webhook",
                    },
                    on: {
                      click: function () {
                        return _vm.toggleSelectedTab("webhook")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("webhook"),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("auto.designerMenuWebhook")) +
                        "\n            "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "SupsisButton",
              {
                attrs: {
                  primary: _vm.selectedTab === "Plan & Tasks",
                  ghost: _vm.selectedTab !== "plan-tasks",
                },
                on: {
                  click: function () {
                    return _vm.toggleSelectedTab("plan-tasks")
                  },
                },
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("dynamic_feed"),
                ]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.planAndTask")) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "SupsisButton",
              {
                attrs: {
                  primary: _vm.selectedTab === "insights",
                  ghost: _vm.selectedTab !== "insights",
                },
                on: {
                  click: function () {
                    return _vm.toggleSelectedTab("insights")
                  },
                },
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("insights"),
                ]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.insights")) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _vm.automation.options.trigger === "event" &&
            _vm.isPreFilterSupported
              ? _c(
                  "SupsisButton",
                  {
                    attrs: {
                      primary: _vm.selectedTab === "prefilters",
                      ghost: _vm.selectedTab !== "prefilters",
                    },
                    on: {
                      click: function () {
                        return _vm.toggleSelectedTab("prefilters")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("filter_alt"),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("automation.preFilters")) +
                        "\n                "
                    ),
                    _vm.preFilterCount > 0
                      ? _c("span", { staticClass: "prefilter-count-badge" }, [
                          _vm._v(_vm._s(_vm.preFilterCount)),
                        ])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isMessageMatchedAutomation
              ? _c(
                  "SupsisButton",
                  {
                    attrs: {
                      primary: _vm.selectedTab === "message-filters",
                      ghost: _vm.selectedTab !== "message-filters",
                    },
                    on: {
                      click: function () {
                        return _vm.toggleSelectedTab("message-filters")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("mail"),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("auto.designerMenuMesajFiltresi")) +
                        "\n            "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.automation.reference && _vm.automation.reference.table
              ? _c("SupsisButton", { on: { click: _vm.goToTable } }, [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("table_view"),
                  ]),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("auto.designerMenuGoToTable")) +
                      "\n            "
                  ),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _vm.selectedTab
      ? _c(
          "div",
          {
            staticClass: "side-bar",
            class: {
              "timer-trigger": _vm.automation.options.trigger === "timer",
            },
          },
          [
            _vm.selectedTab === "scheduler"
              ? _c("AutomationScheduler", {
                  attrs: { automation: _vm.automation },
                  on: {
                    close: function () {
                      return _vm.toggleSelectedTab("designer")
                    },
                    updateAutomation: function ($event) {
                      return _vm.$emit("updateAutomation", $event)
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.selectedTab === "target-contacts"
              ? _c("AutomationContactSelector", {
                  attrs: { automation: _vm.automation },
                  on: {
                    close: function () {
                      return _vm.toggleSelectedTab("designer")
                    },
                    updateAutomation: function ($event) {
                      return _vm.$emit("updateAutomation", $event)
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.selectedTab === "webhook"
              ? _c("AutomationWebhookDetails", {
                  attrs: { automation: _vm.automation },
                  on: {
                    close: function () {
                      return _vm.toggleSelectedTab("designer")
                    },
                    updateAutomation: function ($event) {
                      return _vm.$emit("updateAutomation", $event)
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.selectedTab === "plan-tasks"
              ? _c("AutomationTaskHistory", {
                  attrs: {
                    automation: _vm.automation,
                    "default-automation-id": _vm.automation._id,
                  },
                  on: {
                    close: function () {
                      return _vm.toggleSelectedTab("designer")
                    },
                    updateAutomation: function ($event) {
                      return _vm.$emit("updateAutomation", $event)
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.selectedTab === "insights"
              ? _c("AutomationInsights", {
                  attrs: { automation: _vm.automation },
                  on: {
                    close: function () {
                      return _vm.toggleSelectedTab("designer")
                    },
                    updateAutomation: function ($event) {
                      return _vm.$emit("updateAutomation", $event)
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.selectedTab === "prefilters"
              ? _c("AutomationPreFilters", {
                  attrs: { automation: _vm.automation },
                  on: {
                    close: function () {
                      return _vm.toggleSelectedTab("designer")
                    },
                    updateAutomation: function ($event) {
                      return _vm.$emit("updateAutomation", $event)
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.selectedTab === "message-filters"
              ? _c("AutomationMessageFilters", {
                  attrs: { automation: _vm.automation },
                  on: {
                    close: function () {
                      return _vm.toggleSelectedTab("designer")
                    },
                    updateAutomation: function ($event) {
                      return _vm.$emit("updateAutomation", $event)
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }